

enum Permission {
    Offices_Read = 'Offices_Read',
    Offices_Admin = 'Offices_Admin',

    WorkSites_Read = 'WorkSites_Read',
    WorkSites_Admin = 'WorkSites_Admin',

    Employees_Read = 'Employees_Read',
    Employees_Admin = 'Employees_Admin',

    KeyVaults_Read = 'KeyVaults_Read',
    KeyVaults_Admin = 'KeyVaults_Admin',
    GlobalKeyVaults_Read = 'GlobalKeyVaults_Read',

    KeyTags_Read = 'KeyTags_Read',
    KeyTags_Admin = 'KeyTags_Admin',

    KeyData_Read = 'KeyData_Read',
    KeyData_Operate = 'KeyData_Operate',
    KeyData_Admin = 'KeyData_Admin',

    Teams_Read = 'Teams_Read',

    VisitReports_Read = 'VisitReports_Read',
    VisitReports_Admin = 'VisitReports_Admin',

    Neighbourhoods_Read = 'Neighbourhoods_Read',
    Neighbourhoods_Admin = 'Neighbourhoods_Admin',

    Desks_Read = 'Desks_Read',

    Floors_Read = 'Floors_Read',

    SeatingPlans_Read = 'SeatingPlans_Read',
    SeatingPlans_Execute = 'SeatingPlans_Execute',
    SeatingPlans_Admin = 'SeatingPlans_Admin',

    NewJoiners_Read = 'NewJoiners_Read',
    NewJoiners_Admin = 'NewJoiners_Admin',

    NewJoinerChecklistItems_Read = 'NewJoinerChecklistItems_Read',
    NewJoinerChecklistItems_Admin = 'NewJoinerChecklistItems_Admin',

    SlackSettings_Read = 'SlackSettings_Read',
    SlackSettings_Admin = 'SlackSettings_Admin',

    UserRoles_Read = 'UserRoles_Read',
    UserRoles_Admin = 'UserRoles_Admin',

    PermanentTokens_Read = 'PermanentTokens_Read',
    PermanentTokens_Admin = 'PermanentTokens_Admin',

    ClientLoggers_Admin = 'ClientLoggers_Admin',
}

export default Permission;


export const Offices_Read = Permission.Offices_Read;
export const Offices_Admin = Permission.Offices_Admin;
export const WorkSites_Read = Permission.WorkSites_Read;
export const WorkSites_Admin = Permission.WorkSites_Admin;
export const Employees_Read = Permission.Employees_Read;
export const Employees_Admin = Permission.Employees_Admin;
export const KeyVaults_Read = Permission.KeyVaults_Read;
export const KeyVaults_Admin = Permission.KeyVaults_Admin;
export const GlobalKeyVaults_Read = Permission.GlobalKeyVaults_Read;
export const KeyTags_Read = Permission.KeyTags_Read;
export const KeyTags_Admin = Permission.KeyTags_Admin;
export const KeyData_Read = Permission.KeyData_Read;
export const KeyData_Operate = Permission.KeyData_Operate;
export const KeyData_Admin = Permission.KeyData_Admin;
export const Teams_Read = Permission.Teams_Read;
export const VisitReports_Read = Permission.VisitReports_Read;
export const VisitReports_Admin = Permission.VisitReports_Admin;
export const Neighbourhoods_Read = Permission.Neighbourhoods_Read;
export const Neighbourhoods_Admin = Permission.Neighbourhoods_Admin;
export const Desks_Read = Permission.Desks_Read;
export const Floors_Read = Permission.Floors_Read;
export const SeatingPlans_Read = Permission.SeatingPlans_Read;
export const SeatingPlans_Execute = Permission.SeatingPlans_Execute;
export const SeatingPlans_Admin = Permission.SeatingPlans_Admin;
export const NewJoiners_Read = Permission.NewJoiners_Read;
export const NewJoiners_Admin = Permission.NewJoiners_Admin;
export const NewJoinerChecklistItems_Read = Permission.NewJoinerChecklistItems_Read;
export const NewJoinerChecklistItems_Admin = Permission.NewJoinerChecklistItems_Admin;
export const SlackSettings_Read = Permission.SlackSettings_Read;
export const SlackSettings_Admin = Permission.SlackSettings_Admin;
export const UserRoles_Read = Permission.UserRoles_Read;
export const UserRoles_Admin = Permission.UserRoles_Admin;
export const PermanentTokens_Read = Permission.PermanentTokens_Read;
export const PermanentTokens_Admin = Permission.PermanentTokens_Admin;
export const ClientLoggers_Admin = Permission.ClientLoggers_Admin;
